// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qBSA","signatureBlock":"Footer_signatureBlock__1rbTJ","signature":"Footer_signature__1IibG"};